import { config } from '../constants/config_constants';
import { AVATAR_ID_COOKIE, AVATAR_UUID_COOKIE, BSAUTH_COOKIE,
    LOGIN_TOKEN_TYPE_BSAUTH, LOGIN_TOKEN_TYPE_SNAPCHAT, LOGIN_TOKEN_TYPE_COOKIE }
    from '../constants/cookie_constants';


const HOMGEPAGE_PATH = config.home_page;
class CookieStorageService {

    static set(name, value, cookieInstance) {
        let isSecure = true;
        let expiryDate = new Date();
        const oneYear = 1;

        // Set the expiry date for the cookie to be one year from right now
        expiryDate.setFullYear(expiryDate.getFullYear() + oneYear);
        if (config.endpoints.BITMOJI_API.includes('devbox')) {
            isSecure = false;
        }

        cookieInstance.set(name, value,
            { path: HOMGEPAGE_PATH, expires: expiryDate, secure: isSecure });
    }

    static get(name,cookieInstance) {
        return cookieInstance.get(name);
    }

    static clearAllCookies(cookieInstance){
        cookieInstance.remove(AVATAR_ID_COOKIE, { path: HOMGEPAGE_PATH });
        cookieInstance.remove(AVATAR_UUID_COOKIE, { path: HOMGEPAGE_PATH });
        cookieInstance.remove(BSAUTH_COOKIE, { path: HOMGEPAGE_PATH });
        cookieInstance.remove(LOGIN_TOKEN_TYPE_BSAUTH, { path: HOMGEPAGE_PATH });
        cookieInstance.remove(LOGIN_TOKEN_TYPE_SNAPCHAT, { path: HOMGEPAGE_PATH });
        cookieInstance.remove(LOGIN_TOKEN_TYPE_COOKIE, { path: HOMGEPAGE_PATH });
    }
}

export default CookieStorageService;



// WEBPACK FOOTER //
// ./src/services/CookieStorageService.js